<template>
  <Public header="company-add">
  <v-app id="app" class="public mt-10">
    <v-main id="add-company">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" class="mb-16">
            <v-card class="elevation-0 pa-2">
              <v-card-text class="text--primary pb-0">
                <v-row class="mb-6 mx-0">
                  <v-col class="btn-user-type-left text-center" :style="companyObject.registerType === 'niti' && 'background-color: #6ec39b; color: #fff'" @click="companyObject.registerType = 'niti'">นิติบุคคล</v-col>
                  <v-col class="btn-user-type-right text-center" :style="companyObject.registerType === 'general' && 'background-color: #6ec39b; color: #fff'" @click="companyObject.registerType = 'general'">บุคคลธรรมดา</v-col>
                </v-row>
                <div class="mb-2">เลขประจำตัวนิติบุคคล 13 หลัก *</div>
                <div class="tw-overflow-auto">
                  <OtpInput
                    ref="otpInput"
                    input-classes="otp-input"
                    separator=""
                    :num-inputs="13"
                    :should-auto-focus="false"
                    :is-input-num="true"
                    @on-change="onChangeInputTaxID"
                    @on-complete="onChangeInputTaxID"
                  />
                </div>
                <div v-if="alertTaxID" class="input-address-error mt-4 mb-6">
                  กรุณากรอกข้อมูลให้ครบ 13 ตัวอักษร
                </div>
                <form ref="form" @submit="submit" id="register">
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        v-model="companyObject.nameTH"
                        placeholder=" "
                        outlined
                        :label="companyObject.registerType === 'niti'? 'ชื่อนิติบุคคล / ชื่อบริษัท (Thai) *': 'ชื่อร้านค้า (Thai) *'"
                        :rules="inputRule"
                      :disabled="loading"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        v-model="companyObject.nameEN"
                        placeholder=" "
                        outlined
                        :label="companyObject.registerType === 'niti'? 'ชื่อนิติบุคคล / ชื่อบริษัท (English) *': 'ชื่อร้านค้า (English) *'"
                        :rules="inputRule"
                      :disabled="loading"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-select
                        v-model="companyObject.type"
                        :items="companyObject.registerType === 'niti' ? companyTypeList : shopTypeList"
                        :label="companyObject.registerType === 'niti' ? 'ประเภทบริษัท' : 'ประเภทร้านค้า'"
                        outlined
                      ></v-select>
                    </v-col>
                     <v-col cols="12" md="6" class="pb-0 pt-0" v-if="companyObject.type === 8">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="ระบุ"
                        v-model="companyObject.typeOther"
                        :rules="inputSelectOtherRule"
                        :disabled="loading"
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pb-0 pt-0">
                      <v-checkbox
                        v-model="companyObject.registerTax"
                        outlined
                        label="จดทะเบียนภาษีมูลค่าเพิ่ม"
                        :disabled="loading"
                      ></v-checkbox>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="12" class="pb-0 pt-5 ">
                      <p><strong>ที่อยู่</strong></p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="เลขที่"
                        v-model="companyObject.address.addressNo"
                        :rules="inputRule"
                        :disabled="loading"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="อาคาร / ชั้น / ห้อง"
                        v-model="companyObject.address.building"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="ตรอก / ซอย"
                        v-model="companyObject.address.alley"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="หมู่ที่"
                        v-model="companyObject.address.village"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="ถนน"
                        v-model="companyObject.address.street"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="material-textfield">
                        <ThailandAutoComplete v-model="companyObject.address.postCode" type="zipcode" @select="select"
                                              size="large" color="#42b883" placeholder=" "/>
                        <label>รหัสไปรษณีย์</label>
                      </div>
                      <div v-if="alertZipcode" class="input-address-error">
                        กรุณากรอกข้อมูล
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pt-0 pb-4">
                      <div class="material-textfield">
                        <ThailandAutoComplete v-model="companyObject.address.district" type="amphoe" @select="select"
                                              color="#42b883" size="large" placeholder=" "/>
                        <label>เขต / อำเภอ</label>
                      </div>
                      <div v-if="alertAmphoe" class="input-address-error">
                        กรุณากรอกข้อมูล
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pt-0 pb-4">
                      <div class="material-textfield">
                        <ThailandAutoComplete v-model="companyObject.address.subDistrict" type="district"
                                              @select="select" color="#42b883" size="large" placeholder=" "/>
                        <label>แขวง / ตำบล</label>
                      </div>
                      <div v-if="alertDistrict" class="input-address-error">
                        กรุณากรอกข้อมูล
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="material-textfield">
                        <ThailandAutoComplete v-model="companyObject.address.province" type="province" @select="select" size="large" color="#42b883" placeholder=" "/>
                        <label>จังหวัด</label>
                      </div>
                      <div v-if="alertProvince" class="input-address-error">
                        กรุณากรอกข้อมูล
                      </div>
                    </v-col>

                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="เบอร์โทรศัพท์สำนักงาน"
                        v-model="companyObject.officeNumber"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="เบอร์โทรสาร"
                        v-model="companyObject.faxNumber"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="เบอร์โทรศัพท์มือถือ"
                        v-model="companyObject.phoneNumber"
                        :disabled="loading"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-text-field
                        placeholder=" "
                        outlined
                        label="อีเมล"
                        v-model="companyObject.email"
                        type="email"
                        :rules="inputRule"
                        :disabled="loading"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <v-file-input
                        v-model="companyObject.logo"
                        color="primary"
                        label="Logo"
                        placeholder="Select your logo file"
                        prepend-icon="mdi-paperclip"
                        outlined
                        :rules="logoRule"
                        :disabled="loading"
                        required
                      >
                      </v-file-input>
                    </v-col>
                  </v-row>
                </form>
              </v-card-text>
              <save-alert :status="newCompany ? 'success': 'error'"
                          error-text="เพิ่มบริษัทไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                          success-text="เพิ่มบริษัทสำเร็จ" v-if="newCompany"></save-alert>
              <v-card-actions class="pt-0" style="margin: 0 auto;">
                <v-row align="center">
                  <v-col align="right" class="pt-0">
                    <v-btn class="btn-form" type="button" color="primary" outlined :disabled="loading" :to="'/'">
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="green"
                        style="margin-right: 10px;"
                      ></v-progress-circular>
                      ย้อนกลับ
                    </v-btn>
                  </v-col>
                  <v-col class="pt-0">
                    <v-btn class="btn-form" type="submit" color="primary" form="register" :disabled="loading">
                      <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="green"
                        style="margin-right: 10px;"
                      ></v-progress-circular>
                      ดำเนินการต่อ
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <footer-web></footer-web>
    </v-main>
  </v-app>
  </Public>
</template>

<script>
import FooterWeb from '@/components/public/footer'
import {mapState} from "vuex";
import SaveAlert from "../../components/admin/save-alert"
import router from "@/router";
import "firebase/auth"
import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
import createCompany from "@/libs/createCompany";
import {checkImageSmall} from "../../libs/validateImageUpload";
import OtpInput from "@bachdgvn/vue-otp-input";
import Public from '@/components/public/public-main-template'
import updatePackage from "@/libs/updatePackage";

const _ = require('lodash');

export default {
  name: 'AddCompany',
  components: {
    Public,
    FooterWeb,
    SaveAlert,
    ThailandAutoComplete,
    OtpInput
  },
  computed: mapState({
    newCompany: state => state.companies.newCompany
  }),
  mounted() {
    let elements = document.getElementsByClassName("vth-addr-input vth-addr-input-size-large")
    for (let i=0; i<elements.length; i++) {
      elements[i].setAttribute("required", "required");
      if (i === 0) elements[i].setAttribute("id", "zipcode");
      if (i === 1) elements[i].setAttribute("id", "amphoe");
      if (i === 2) elements[i].setAttribute("id", "district");
      if (i === 3) elements[i].setAttribute("id", "province");

      elements[i].setAttribute("autocomplete", "off");

      elements[i].addEventListener('focusout', (event) => {
        if (event.target.value === '') {
          event.target.classList.add("input-error");
          event.target.parentNode.parentNode.nextElementSibling.classList.add("text-color-error")
          if (event.target.id === 'province') {
            this.alertProvince = true;
          }
          if (event.target.id === 'amphoe') {
            this.alertAmphoe = true;
          }
          if (event.target.id === 'district') {
            this.alertDistrict = true;
          }
          if (event.target.id === 'zipcode') {
            this.alertZipcode = true;
          }
        }
      });

      elements[i].addEventListener("keypress", () => {
        for (let i=0; i<elements.length; i++) {
          elements[i].classList.remove("input-error");
          elements[i].parentNode.parentNode.nextElementSibling.classList.remove("text-color-error")
          this.alertProvince = false;
          this.alertAmphoe = false;
          this.alertDistrict = false;
          this.alertZipcode = false;
        }
      });
    }
  },
  data() {
    return {
      companyObject:{
        nameTH: "",
        nameEN: "",
        taxID: "",
        address:{
          addressNo: "",
          building: "",
          village: "",
          alley: "",
          street: "",
          province: "",
          district: "",
          subDistrict: "",
          postCode: "",
        },
        officeNumber:"",
        faxNumber:"",
        phoneNumber:"",
        email: "",
        logo: null,
        type: 0,
        typeOther:"",
        registerTax : false,
        registerType: "niti"
      },

      inputRule:[
        v => !!v || 'กรุณากรอกข้อมูล',
      ],
      inputSelectOtherRule:[
        v => (this.companyObject.type === 8 && !!v) || 'กรุณากรอกข้อมูล',
      ],
      taxIDRule:[
        v => !!v || 'กรุณากรอกข้อมูล',
        v => (v && v.length === 13) || 'เลขประจำตัวผู้เสียภาษีควรมี 13 ตัวอักษร',
      ],
      postCodeRule: [
        v => (v && v.length === 5) || 'รหัสไปรษณีย์ควรมี 5 ตัวอักษร',
      ],
      logoRule: [
        v => (v && v.length !== 0) || 'กรุณาเลือกไฟล์รูป',
      ],
      loading: false,

      alertProvince: false,
      alertAmphoe: false,
      alertDistrict: false,
      alertZipcode: false,
      alertTaxID: false,
      companyTypeList: [
        {text: "บริษัทจำกัด", value: 1},
        {text: "บริษัทจำกัดมหาชน", value: 2},
        {text: "ห้างหุ้นส่วนจำกัด", value: 3},
        {text: "ห้างหุ้นส่วนสามัญ", value: 4},
        {text: "คณะบุคคล", value: 5},
        {text: "มูลนิธิ", value: 6},
        {text: "สมาคม", value: 7},
        {text: "อื่นๆ", value: 8}
        ],
      shopTypeList: [
        {text: "ขายออนไลน์ e-commerce", value: 1},
        {text: "ร้านค้าปลีกในรูปแบบการขายส่ง", value: 2},
        {text: "ร้านค้าปลีกขายสินค้าเฉพาะอย่าง", value: 3},
        {text: "ร้านขายของชำ", value: 4}
        ],
    }
  },
  methods: {
    submit: async function (e) {
      e.preventDefault();
      if (this.companyObject.taxID.length !== 13) {
        this.alertTaxID = true
        this.onsetClassOtpInput("add")
      } else {
        this.loading = true
        await createCompany(this.companyObject, this.$store.dispatch).then(async (companyID)=> {
          this.loading = false;
          let packageObject = {paymentPlanID: "free_month", partnerID: ""}
          await updatePackage(packageObject, companyID, true)

          await router.push(companyID? `${companyID}/package`: "/companies-list")
        })
      }
    },
    select (address) {
      this.companyObject.address.subDistrict = address.district
      this.companyObject.address.district = address.amphoe
      this.companyObject.address.province = address.province
      this.companyObject.address.postCode = address.zipcode
    },
    onsetClassOtpInput: function(type){
      let elements = document.getElementsByClassName("otp-input")
      for (let i=0; i<elements.length; i++) {
        if(type === "add"){
          elements[i].classList.add("error");
        }else {
          elements[i].classList.remove("error");
        }
      }
    },
    onChangeInputTaxID: function (value) {
      console.log("onChangeInputTaxID ...")

      if(value && value.length !== 13){
        this.alertTaxID = true
        this.onsetClassOtpInput("add")
      }else {
        this.alertTaxID = false
        this.onsetClassOtpInput("remove")
      }
      this.companyObject.taxID = value
    }
  },
  watch:{
    newCompany:{
      handler: function (){
        if (this.newCompany){
          this.loading = false
        }
      }
    },
    'companyObject.logo': {
      handler: function (newVal) {
        if (newVal) {
          checkImageSmall(newVal).then((imageSmall) => {
            if (imageSmall) {
              _.set(this.companyObject, 'logo', null)
              alert("width lower 640 pixels. please select new image.")
            }
          })
        }

      }, deep: true
    },
    'companyObject.registerType': {
      handler: function (newVal) {
        if (newVal) {
          this.companyObject.type = 0
        }
      }, deep: true
    },
  }
}
</script>

<style lang="scss">
#add-company {
  * {
    font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
  }

  .add-company-logo {
    width: 100px;
    display: block;
    margin: 20px auto;
  }

  .v-input__prepend-outer {
    display: none;
  }

  input {
    font-size: 16px;
  }

  .material-textfield {
    position: relative;

    label {
      position: absolute;
      font-size: 12px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: white;
      color: rgba(0, 0, 0, 0.6);
      padding: 0 0.3rem;
      margin: 0 0.5rem;
      transition: .1s ease-out;
      transform-origin: left top;
      pointer-events: none;
      line-height: 10px;

      &.text-color-error {
        color: #b71c1c !important;
      }
    }

    input {
      border-radius: 4px !important;
      border: 1px solid rgba(0, 0, 0, 0.4) !important;
      //color: rgba(0, 0, 0, 0.6);
      transition: 0.5s ease-out;

      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.87) !important;
      }

      &:focus {
        border: 2px solid #6ec39b !important;
      }

      &.input-error {
        border: 2px solid #b71c1c !important;
      }
    }

    .vth-addr-container:focus-within + label {
      color: #6ec39b;
    }

    input[type="text"] {
      min-height: 56px;
      //padding: 12px 10px;
      line-height: 28px;
    }
  }

  .vth-addr-input-size-large[data-v-1f53c317] {
    font-size: 16px;
  }

  .vth-addr-input[data-v-1f53c317] {
    border-radius: 10px !important;
    line-height: unset;
    box-shadow: unset;
  }

  *[data-v-1f53c317] {
    font-family: unset;
  }

  .input-address-error {
    font-size: 12px;
    color: #b71c1c;
    line-height: 2px;
    word-break: break-word;
    overflow-wrap: break-word;
    word-wrap: break-word;
    margin-left: 13px;
  }

  .btn-user-type-right {
    border: solid 1px #c4c4c4;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    border-left: none;
  }

  .btn-user-type-left {
    border: solid 1px #c4c4c4;
    border-radius: 10px 0 0 10px;
    cursor: pointer;
    border-right: none;
  }

  .otp-input {
    width: 40px;
    height: 44px;
    margin-left: 5px;
    margin-bottom: 30px;
    font-size: 16px;
    border-radius: 10px;
    border: solid 1px #c4c4c4;
    text-align: center;

    &.error {
      background-color: white !important;
      border: 1px solid #b71c1c !important;
      margin-bottom: 0;
    }
  }

  div[is-input-num=true] div:first-child input {
    margin-left: 0;
  }

  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  fieldset {
    border-radius: 10px
  }

  .btn-form {
    width: 150px;
    height: 44px;
    font-weight: bold;
    border-radius: 10px;
  }
}
</style>
